module.exports = "/fonts/NanumGothic-Regular.ttf?6c84540de7730f833d6c51f60232d769";